import { render, staticRenderFns } from "./AppSelector.vue?vue&type=template&id=50321b52&"
import script from "./AppSelector.vue?vue&type=script&lang=js&"
export * from "./AppSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports